const config = window.AbdelmegedTheme || {};
const endpoint = `${config.restUrl || '/wp-json/abdelmeged/v1'}/content/cards`;

const roots = document.querySelectorAll('[data-ajax-content-root]');

const axisFromLink = (link) => {
  if (link.dataset.ajaxContentAxis !== undefined) {
    return link.dataset.ajaxContentAxis;
  }

  try {
    return new URL(link.href, window.location.origin).searchParams.get('axis') || '';
  } catch {
    return '';
  }
};

const requestUrl = (root, link) => {
  const url = new URL(endpoint, window.location.origin);
  const axis = axisFromLink(link);
  const format = root.dataset.ajaxContentFormat || '';
  const context = root.dataset.ajaxContentContext || 'archive';
  const limit = root.dataset.ajaxContentLimit || (context === 'home' ? '8' : '24');

  if (axis !== '') {
    url.searchParams.set('axis', axis);
  }

  if (format !== '') {
    url.searchParams.set('format', format);
  }

  url.searchParams.set('context', context);
  url.searchParams.set('limit', limit);

  return url;
};

const setLoading = (root, target, isLoading) => {
  root.classList.toggle('is-loading', isLoading);
  target.setAttribute('aria-busy', String(isLoading));
};

const setActiveTab = (root, activeLink) => {
  root.querySelectorAll('[data-ajax-content-tab]').forEach((link) => {
    const isActive = link === activeLink;

    link.classList.toggle('is-active', isActive);

    if (isActive) {
      link.setAttribute('aria-current', 'page');
      return;
    }

    link.removeAttribute('aria-current');
  });
};

const loadTab = async (root, link) => {
  const target = root.querySelector('[data-ajax-content-target]');

  if (!target || root.classList.contains('is-loading')) {
    return;
  }

  root.classList.remove('has-load-error');
  setLoading(root, target, true);

  try {
    const response = await fetch(requestUrl(root, link), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Content request failed.');
    }

    const payload = await response.json();

    if (typeof payload?.html !== 'string') {
      throw new Error('Content response is missing HTML.');
    }

    target.innerHTML = payload.html;
    setActiveTab(root, link);
    window.dispatchEvent(new CustomEvent('abdelmeged:content-loaded', {
      detail: {
        axis: payload.axis || '',
        context: payload.context || root.dataset.ajaxContentContext || 'archive',
        count: Number(payload.count || 0),
        root,
      },
    }));
  } catch {
    root.classList.add('has-load-error');
    window.dispatchEvent(new CustomEvent('abdelmeged:content-load-failed', {
      detail: {
        axis: axisFromLink(link),
        context: root.dataset.ajaxContentContext || 'archive',
        root,
      },
    }));
  } finally {
    setLoading(root, target, false);
  }
};

roots.forEach((root) => {
  root.querySelectorAll('[data-ajax-content-tab]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      event.preventDefault();
      loadTab(root, link);
    });
  });
});
